var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.174,
    height: 51.158,
    viewBox: "0 0 51.174 51.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(20557.123 -3888.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M278.543,331.222a20.22,20.22,0,1,1-20.262,20.133A20.276,20.276,0,0,1,278.543,331.222ZM278.515,336a15.451,15.451,0,1,0,15.435,15.451A15.356,15.356,0,0,0,278.515,336Z",
    transform: "translate(-20804.678 3557.57)",
    fill: "#57bedf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M236.154,461.033a10.989,10.989,0,0,1-1.39,2.288c-2.114,2.252-4.327,4.414-6.535,6.575a3.889,3.889,0,0,1-5.8.109c-1.571-1.612-1.5-3.91.24-5.685,2.231-2.276,4.478-4.538,6.769-6.752a3.729,3.729,0,0,1,4.535-.689C235.441,457.648,236.1,458.914,236.154,461.033Z",
    transform: "translate(-20778.432 3468.703)",
    fill: "#57bedf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M305.874,377.818c-3.353,1.176-3.482,1.182-3.3,4.53a3.69,3.69,0,0,1-2.393,3.922c-5.748,2.92-6.652,2.936-12.293.15-1.873-.925-2.865-2.049-2.678-4.336.239-2.92.055-2.929-2.662-4.088-.551-.235-1.075-.531-2-.994,2.25-.994,4.117-1.83,5.994-2.645,2.029-.882,4.042-1.812,6.115-2.579a3.482,3.482,0,0,1,2.3-.043c3.617,1.45,7.168,3.06,10.775,4.537A1.51,1.51,0,0,1,306.811,378c-.055,1.148-.268,2.3,1.027,3.159.822.542.593,2.034-.209,2.683a1.847,1.847,0,0,1-2.616-.058c-.779-.694-.943-2.165-.095-2.693C306.3,380.227,305.819,379.049,305.874,377.818Zm-22.766-.78c3.672,1.561,7.033,3,10.409,4.406a1.4,1.4,0,0,0,.969-.051c2.824-1.185,5.635-2.4,8.824-3.769-2.986,0-5.542.039-8.1-.028a6.827,6.827,0,0,1-1.83-.586,6.713,6.713,0,0,1,1.863-.638c2.378-.076,4.76-.03,7.141-.03-2.621-1.381-5.271-2.525-7.934-3.638a1.4,1.4,0,0,0-.967-.058C290.116,374.048,286.76,375.486,283.109,377.038Zm3.1,2.607a28.27,28.27,0,0,1-.022,3.1,2.1,2.1,0,0,0,1.387,2.4c1.892.837,3.782,1.679,5.69,2.478a1.543,1.543,0,0,0,1.08.062c2.121-.908,4.234-1.84,6.308-2.85a1.754,1.754,0,0,0,.876-1.169c.117-1.233.042-2.485.042-4.007-2.273.978-4.308,1.941-6.412,2.71a3.825,3.825,0,0,1-2.428.005C290.572,381.589,288.485,380.614,286.209,379.645Zm20.1,4.35c.526-.786,1.024-1.209,1.031-1.64.006-.352-.637-1.043-.882-1a1.572,1.572,0,0,0-1.1.96C305.3,382.705,305.823,383.184,306.314,383.995Z",
    transform: "translate(-20820.48 3528.932)",
    fill: "#57bedf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2);
export default __webpack_public_path__ + "static/media/cp2.e8c06ea78b86a3e7bb86ad25618f0511.svg";
export { ForwardRef as ReactComponent };